import React from 'react';

function EnhancedFDICDisclosure() {
    return (
        <>
            Your deposits qualify for up to $3,000,000 in FDIC insurance coverage when placed at program banks
            in the Thread Bank deposit sweep program. Your deposits at each program bank become eligible for FDIC insurance
            up to $250,000, inclusive of any other deposits you may already hold at the bank in the same ownership capacity.
            You can access the terms and conditions of the sweep program and a list of program banks at {' '}
            <a href="https://www.thread.bank/faq">https://www.thread.bank/faq</a>. {' '}
            Please contact <a href="mailto:customerservice@thread.bank">customerservice@thread.bank</a> {' '} with questions on the program.
        </>
    );
}

export default EnhancedFDICDisclosure;
